import { message } from 'antd';
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';

import { LoadingContext } from '~/contexts/LoaderContext';
import { GeneralException } from '~/exceptions/generalException';
import { ABANDONED_PAGE_ROUTE, ERROR_PAGE_ROUTE, HOME_ROUTE } from '~/routing/routes';
import { PaymentService } from '~/services/PaymentService';
import { isTransactionNotFoundError } from '~/utils/paymentResultUtils';

import './GetPaymentStatus.scss';

const GetPaymentStatus: React.FC = () => {
  const location = useLocation();
  const { push: redirect } = useHistory();

  const { startLoading, stopLoading } = useContext(LoadingContext);

  const { t } = useTranslation();

  const getTransactionDetails = useCallback(async (transactionRef: string) => {
    startLoading();
    try {
      const res = await PaymentService.getTransactionDetails(transactionRef);
      const {
        data,
        data: {
          transaction: { status },
        },
      } = res;

      if (data !== null && data !== undefined) {
        switch (
          status // transaction.status
        ) {
          case 'ACCEPTED': // successful
            redirect(HOME_ROUTE()); // SUCCESS_PAGE_ROUTE
            break;
          case 'PAYMENT_ALREADY_PROCESSED':
            redirect(HOME_ROUTE()); // Paiement déjà effectué
            break;
          case 'REFUSED': // failed REJECTED
            redirect(HOME_ROUTE());
            break;
          case 'PENDING':
            redirect(HOME_ROUTE());
            break;
          case 'REJECTED':
            redirect(HOME_ROUTE());
            break;
          default:
            redirect(ERROR_PAGE_ROUTE());
            break;
        }
      } else {
        redirect(ERROR_PAGE_ROUTE());
      }
      stopLoading();
    } catch (error: unknown) {
      stopLoading();
      if (isTransactionNotFoundError(error)) {
        redirect(ABANDONED_PAGE_ROUTE());
        return;
      }
      const exception = (error as { response?: { data?: GeneralException } })?.response?.data as GeneralException;
      message.error(exception?.description || t('home:global:generalResponse'), 3);
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const transactionRef = String(queryParams.get('transactionRef'));
    getTransactionDetails(transactionRef);
  }, []);

  return (
    <div className="getPaymentStatus">
      <div></div>
    </div>
  );
};

export default GetPaymentStatus;
